import { render, staticRenderFns } from "./Stills.vue?vue&type=template&id=1085c588&"
import script from "./Stills.vue?vue&type=script&lang=js&"
export * from "./Stills.vue?vue&type=script&lang=js&"
import style0 from "./Stills.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1085c588')) {
      api.createRecord('1085c588', component.options)
    } else {
      api.reload('1085c588', component.options)
    }
    module.hot.accept("./Stills.vue?vue&type=template&id=1085c588&", function () {
      api.rerender('1085c588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/summary/components/Stills.vue"
export default component.exports